export interface DecodedData {
  redirectUri: string;
  scope: string;
  state: string;
  responseType: string;
}

export const getParamfromUrl = (url: string, key: string) => {
  const params = new URLSearchParams(new URL(url).search);
  const keyValue = params.get(key);
  return keyValue || "";
};

export const decodeBase64 = (value: string) => {
  let obj = <DecodedData>{};
  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    obj = JSON.parse(window.atob(value));
  } catch (e) {
    return obj;
  }
  return obj;
};
